import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";

import HrDocuments from "../features/hr_documents";
import HrDocumentsOutlet from "../features/hr_documents/pages/HrDocumentsOutlet/HrDocumentsOutlet";
import HrDocumentsSocietyOutlet from "../features/hr_documents/pages/HrDocumentsSociety/HrDocumentsSocietyOutlet";
import HrDocumentsFolders from "../features/hr_documents/pages/HrDocumentsSociety/HrDocuments";
import HrDocumentsCommonDocuments from "../features/hr_documents/pages/HrDocumentsSociety/HrDocumentsCommonDocuments";
import HrDocumentsExpenses from "../features/hr_documents/pages/HrDocumentsSociety/HrDocumentsExpenses";
import HrDocumentsLeave from "../features/hr_documents/pages/HrDocumentsSociety/HrDocumentsLeave";
import HrDocumentsTimesheet from "../features/hr_documents/pages/HrDocumentsSociety/HrDocumentsTimesheet";

// documents HR
export const documentsHrRoutes = (
    <Route
        path={ROUTES.document_hr.home}
        element={<HrDocumentsOutlet />}
        key="document_hr"
    >
        <Route index path={ROUTES.document_hr.home} element={<HrDocuments />} />
        <Route
            path={ROUTES.document_hr.society}
            element={<HrDocumentsSocietyOutlet />}
        >
            <Route
                index
                path={""}
                element={<HrDocumentsFolders rootIndex={true} />}
            />
            <Route
                index
                path={"hr_documents"}
                element={<HrDocumentsFolders />}
            />
            <Route
                path={"common_documents"}
                element={<HrDocumentsCommonDocuments />}
            />
            <Route path={"expenses"} element={<HrDocumentsExpenses />} />
            <Route path={"leave"} element={<HrDocumentsLeave />} />
            <Route path={"timesheet"} element={<HrDocumentsTimesheet />} />
        </Route>
    </Route>
);
